module.exports = __webpack_public_path__ + "b510cbd6cbe5b2d622a283b1c0b31cfe.jpg";